import React from "react";
import { useReadOnly } from "slate-react";
import { CustomText } from "../types";

interface LeafProps {
  attributes: unknown;
  leaf: CustomText;
  children: unknown;
}

export const Leaf: React.FC<LeafProps> = ({ attributes, children, leaf }) => {
  const readOnly = useReadOnly();
  let childToRender = children;

  if (leaf.bold) {
    childToRender = <strong>{childToRender}</strong>;
  }

  if (leaf.italic) {
    childToRender = <em css={{ fontStyle: "italic" }}>{childToRender}</em>;
  }

  if (leaf.underline) {
    childToRender = (
      <u css={{ textDecoration: "underline" }}>{childToRender}</u>
    );
  }

  if (leaf.link) {
    const href = leaf.link;
    childToRender = (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        css={{ color: "#1a73e8", textDecoration: "underline" }}
        // Prevent the editor from placing the caret when the link is clicked so a
        // plain click inside the open editor opens the link in a new tab instead.
        onMouseDown={(e) => {
          if (!readOnly) {
            e.preventDefault();
          }
        }}
        onClick={(e) => {
          if (readOnly) {
            return;
          }
          e.preventDefault();
          window.open(href, "_blank", "noopener,noreferrer");
        }}
      >
        {childToRender}
      </a>
    );
  }

  // @ts-expect-error after ts update
  return <span {...attributes}>{childToRender}</span>;
};
